import { ForgotPasswordState } from "@core/models/forgot-password.interface";
import { createFeature, createReducer, on } from "@ngrx/store";
import { forgotPasswordActions } from "./actions";

export const initialForgotPasswordState: ForgotPasswordState = {
  isLoading: false,

  currentEmail: null,
  otpSent: false,

  currentOtp: null,
  otpMatch: false,

  passwordSent: false,
};

export const forgotPasswordFeature = createFeature({
  name: "forgotPassword",
  reducer: createReducer(
    initialForgotPasswordState,

    // Request an OTP
    on(forgotPasswordActions.requestResetPasswordOTP, (state) => ({
      ...state,
      isLoading: true,
    })),
    on(
      forgotPasswordActions.requestResetPasswordOTPSuccess,
      (state, action) => ({
        ...state,
        currentEmail: action.email,
        isLoading: false,
        otpSent: true,
      }),
    ),
    on(forgotPasswordActions.requestResetPasswordOTPFailed, (state) => ({
      ...state,
      isLoading: false,
    })),

    // Check OTP valid
    on(forgotPasswordActions.requestResetPasswordCheckOTP, (state, event) => ({
      ...state,
      isLoading: true,
    })),
    on(
      forgotPasswordActions.requestResetPasswordCheckOTPSuccess,
      (state, action) => ({
        ...state,
        currentOtp: action.otp,
        otpMatch: true,
        isLoading: false,
      }),
    ),
    on(forgotPasswordActions.requestResetPasswordCheckOTPFailed, (state) => ({
      ...state,
      isLoading: false,
    })),

    // Send new password
    on(forgotPasswordActions.requestSendNewPassword, (state, event) => ({
      ...state,
      isLoading: true,
    })),
    on(forgotPasswordActions.requestSendNewPasswordSuccess, (state) => ({
      ...state,
      passwordSent: true,
      isLoading: false,
    })),
    on(forgotPasswordActions.requestSendNewPasswordFailed, (state) => ({
      ...state,
      isLoading: false,
    })),

    // Reset state steps
    on(forgotPasswordActions.resetStateToStepOne, (state) => ({
      ...initialForgotPasswordState,
    })),
    on(forgotPasswordActions.resetStateToStepTwo, (state) => ({
      ...initialForgotPasswordState,
      currentEmail: state.currentEmail,
    })),
  ),
});

export const {
  name: forgotPasswordFeatureKey,
  reducer: forgotPasswordReducer,
  selectForgotPasswordState,
  selectIsLoading,
  selectOtpSent,
  selectOtpMatch,
  selectCurrentEmail,
  selectPasswordSent,
} = forgotPasswordFeature;
